import pastasGerencias from '~/graphql/pre-defined-filters/pastasGerencias';
import pastasResponsaveis from '~/graphql/pre-defined-filters/pastasResponsaveis';
import { getInicioEFimDoDia } from '~/graphql/pre-defined-filters/utils';

interface PublicacoesHojeOptions {
  gerencia?: number;
  responsaveis?: string[];
}

function createPastaFilter(filters: any[]) {
  return {
    pastasPublicacoesNumerosProcessos: {
      some: {
        pasta: {
          and: filters,
        },
      },
    },
  };
}

export default function (options?: PublicacoesHojeOptions) {
  const [inicioDoDia, finalDoDia] = getInicioEFimDoDia();

  const baseFilter = {
    and: [
      {
        publicacao: {
          dataMovimento: {
            gte: inicioDoDia,
          },
        },
      },
      {
        publicacao: {
          dataMovimento: {
            lte: finalDoDia,
          },
        },
      },
    ],
  };

  const ands: any[] = [baseFilter];

  if (options?.gerencia) {
    ands.push(createPastaFilter(pastasGerencias(options.gerencia)));
  }

  if (options?.responsaveis && options?.responsaveis.length > 0) {
    ands.push(createPastaFilter(pastasResponsaveis(options.responsaveis)));
  }

  return {
    where: {
      and: ands,
    },
  };
}
